'use client';

import type { ReactNode } from 'react';

export interface TabItem {
  key: string;
  label: ReactNode;
}

export function Tabs({
  items,
  value,
  onChange,
  ariaLabel,
}: {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
  ariaLabel?: string;
}) {
  return (
    <div className="mx-tabs" role="tablist" aria-label={ariaLabel}>
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={`mx-tab${value === it.key ? ' mx-tab--active' : ''}`}
          onClick={() => onChange(it.key)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}

/** Segmented control (mx-seg) — varian Tabs untuk pilihan padat (mis. sumber share). */
export function Segmented({
  items,
  value,
  onChange,
  ariaLabel,
}: {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
  ariaLabel?: string;
}) {
  return (
    <div className="mx-seg" role="tablist" aria-label={ariaLabel}>
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={`mx-seg__btn${value === it.key ? ' mx-seg__btn--active' : ''}`}
          onClick={() => onChange(it.key)}
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
